import { Controller } from "react-hook-form"
import { Field, Checkbox } from "@chakra-ui/react"

export default function CheckboxField({ control, rules, name, value, label, help }) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={value || false}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                return (
                    <Field.Root invalid={!!error}>
                        <Checkbox.Root {...field}>
                            <Checkbox.HiddenInput />
                            <Checkbox.Control />
                            <Checkbox.Label>{label}</Checkbox.Label>
                        </Checkbox.Root>
                        {help && <Field.HelperText>{help}</Field.HelperText>}
                        {error && <Field.ErrorText>{error.message}</Field.ErrorText>}
                    </Field.Root>
                )
            }}
        />
    )
}
